function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { useTheme } from 'styled-components';
var BirminghamMidshiresIcon = function BirminghamMidshiresIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1562 3H2.73682L10.9331 12L2.73682 21H14.1562L22.3526 12L14.1562 3ZM13.2721 5L19.6471 12L13.2711 19H7.26308L13.6384 12L7.26408 5H13.2721Z",
    fill: "currentColor"
  }));
};
BirminghamMidshiresIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var BosIcon = function BosIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4848 1V6.38298H0V17.617H12.4848V23L24 12.117L12.4848 1Z",
    fill: "currentColor"
  }));
};
BosIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var HalifaxIcon = function HalifaxIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1562 3H2.73682L10.9331 12L2.73682 21H14.1562L22.3526 12L14.1562 3ZM13.2721 5L19.6471 12L13.2711 19H7.26308L13.6384 12L7.26408 5H13.2721Z",
    fill: "currentColor"
  }));
};
HalifaxIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var LloydsReimaginedIcon = function LloydsReimaginedIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M0 10.8358H19.2643L13.0696 4.98446C12.5873 4.52987 12.5873 3.79553 13.0696 3.34094C13.5518 2.88635 14.3308 2.88635 14.813 3.34094L24 12.0015L14.813 20.662C14.5657 20.8951 14.2566 21 13.9351 21C13.6136 21 13.3045 20.8834 13.0572 20.662C12.575 20.2074 12.575 19.473 13.0572 19.0184L19.2643 13.1671H0V10.8358Z",
    fill: "currentColor"
  }));
};
LloydsReimaginedIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var Lloyds2023Icon = function Lloyds2023Icon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4848 1V6.38298H0V17.617H12.4848V23L24 12.117L12.4848 1Z",
    fill: "currentColor"
  }));
};
Lloyds2023Icon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
import { useBrand } from "../BrandProvider";
import SvgIcon from "../SvgIcon";
import { LLOYDS, BIRMINGHAM_MIDSHIRES, BOS, HALIFAX, LLOYDS2023 } from "../../constants";
export default function ArrowRight(_ref) {
  var _theme$assets, _theme$assets$icons;
  var rest = _extends({}, _ref);
  var _ref2 = useBrand() || {},
    _ref2$brand = _ref2.brand,
    brand = _ref2$brand === void 0 ? LLOYDS : _ref2$brand;
  var theme = useTheme();
  var svg;
  if ((_theme$assets = theme.assets) !== null && _theme$assets !== void 0 && (_theme$assets$icons = _theme$assets.icons) !== null && _theme$assets$icons !== void 0 && _theme$assets$icons.arrow_right) {
    svg = theme.assets.icons.arrow_right;
  } else {
    switch (brand) {
      case BIRMINGHAM_MIDSHIRES:
        svg = BirminghamMidshiresIcon;
        break;
      case BOS:
        svg = BosIcon;
        break;
      case HALIFAX:
        svg = HalifaxIcon;
        break;
      case LLOYDS:
        svg = LloydsReimaginedIcon;
        break;
      case LLOYDS2023:
        svg = Lloyds2023Icon;
        break;
      default:
        console.warn("Icon \"ArrowRight\" is not available for brand ".concat(brand));
        svg = function svg() {
          return null;
        };
    }
  }
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({
    svg: svg
  }, rest));
}